import useOverlay from "@/hooks/common/useOverlay";
import {scrollRestore} from "@/hooks/common/useScrollRestoration";
import {useTaggingClick} from "@/hooks/common/useTagging";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import EventListPopup from "@COMPONENTS/product/common/popup/mobile/EventListPopup";
import useFilterStore from "@COMPONENTS/product/pages/localList/common/filterHook";
import LocalGoods from "@COMPONENTS/product/pages/localList/mobile/goodsList/goods";
import CompareProductsPopup from "@COMPONENTS/product/pages/localList/mobile/popup/CompareProductsPopup";
import * as style from "@COMPONENTS/style/productlist/productlistM";
import {TextButton} from "@FRAMEWORK/ui/mobile/button";
import LoadingBox from "@FRAMEWORK/ui/mobile/layout/LoadingBox";
import WarningBox from "@FRAMEWORK/ui/mobile/layout/WarningBox";
import useGoodsByMenu from "@QUERIES/prdt/goods/useGoodsByMenu";
import {useRouter} from "next/router";
import React, {useState} from "react";

const GoodsListComponent = () => {
	const router = useRouter();
	const dspSid = router.query?.dspSid as string;
	const goodsListFetch = useGoodsByMenu(dspSid);
	const {getFilteringProduct} = useFilterStore();
	const goodsList = getFilteringProduct();
	const [selectedProduct, setSelectedProduct] = useState<string[]>([]);

	const {taggingClick} = useTaggingClick("pkg_select_prod_list");

	const [open] = useOverlay();

	/** scrollRestore 상품 클릭 위치 저장 */
	const {getRestoreData, setRestoreData} = scrollRestore();

	// 비교 상품 선택
	const selectToCompare = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {value, checked} = e.target;
		const isChecked = selectedProduct.includes(value);
		if (selectedProduct.length >= 2 && !isChecked) {
			return MessageUtil.alert("비교상품은 총 2개까지 선택이 가능합니다.");
		}

		if (selectedProduct.length < 2 || isChecked) {
			if (checked) {
				setSelectedProduct([...selectedProduct, value]);
			} else {
				setSelectedProduct(selectedProduct.filter(v => v !== value));
			}
		}
	};

	/** 출발일 팝업 핸들러 */
	const handleDeparturePopup = (goodsCd: string) => {
		/** scrollRestore 상품 클릭 위치 저장 */
		setRestoreData({...getRestoreData(), top: document.scrollingElement.scrollTop});
		// tagging
		taggingClick({goodsCd});
		open(popupProps => <EventListPopup {...popupProps} goodsCd={goodsCd} />);
	};

	/** 비교상품 팝업 핸들러 */
	const compareProducts = () => {
		open(props => (
			<CompareProductsPopup {...props} selected={selectedProduct} showDepartureDayPopup={handleDeparturePopup} />
		));
	};

	const renderGoodsList = () => {
		if (goodsListFetch.isFetching) {
			return <LoadingBox />;
		}

		if (goodsList.length === 0) {
			return <WarningBox>해당하는 상품이 존재하지 않습니다.</WarningBox>;
		}

		return (
			<>
				<style.ProductList>
					{goodsList.map((item, index) => (
						<LocalGoods
							product={item}
							key={index}
							selectedProduct={selectedProduct}
							selectToCompare={selectToCompare}
							handleDeparturePopup={handleDeparturePopup}
						/>
					))}
				</style.ProductList>
			</>
		);
	};

	return (
		<>
			{renderGoodsList()}
			{selectedProduct.length > 1 && (
				<style.CompareButton>
					<TextButton
						onClick={() => setSelectedProduct([])}
						width="basic"
						size="submit"
						types="basic"
						text="선택 해제"
					/>
					<TextButton onClick={compareProducts} width="basic" size="submit" types="confirm" text="상품 비교" />
				</style.CompareButton>
			)}
		</>
	);
};

const LocalGoodsList = () => (
	<ErrorBoundary logMsg="Product List Error">
		<GoodsListComponent />
	</ErrorBoundary>
);

export default LocalGoodsList;
